export default __webpack_public_path__ + "static/media/cif-au.b85a89e1.svg";